module.exports = __webpack_public_path__ + "img/06_TwispWorks.30555629.jpg";